import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from 'moment';

const DateTimeInput = ({
	id = '',
	label = '',
	value,
	onChange,
	error,
	fullWidth = true,
	type = 'date',
	}) => {
	const changeHandler = (dateValue) => {
				const dateTimeFormat = type === 'datetime' ? 'MM/DD/YYYY hh:mm a' : 'MM/DD/YYYY';

		const momentDate = moment(dateValue, '').format(dateTimeFormat);
		onChange({ id, value: momentDate });
	};

	const today = moment();
	const convertedValue = moment(value);
	
	const dateTimePickerProps = {
		id: id,
		fullWidth: fullWidth,
		label: label,
		value: convertedValue.isValid() ? convertedValue : null,
		onChange: changeHandler,
		minDate: today,
		slotProps: {
			textField: {
				helperText: error,
				fullWidth: true,
				error: !!error,
				variant: 'filled',
			},
		},
	};
	return (
		<LocalizationProvider dateAdapter={AdapterMoment}>
			{type === 'datetime' ? (
				<DateTimePicker {...dateTimePickerProps} />
			) : (
				<DatePicker {...dateTimePickerProps} />
			)}
		</LocalizationProvider>
	);
};

export default DateTimeInput;
